import React from "react";

const ToolbarContext = React.createContext();

export default ToolbarContext;
